import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import illustration from '../assets/illustration.webp';
import { NavLink } from 'react-router-dom';

export function HomePage() {
  return (
    <>
      <Header />
      <main>
        <section className="hero">
          <div className="hero-content">
            <h1>Technology Consulting for Not-for-Profits.</h1>
            <p>Empowering your mission with AI, Data, and Cloud solutions.</p>
            <NavLink to="/contact" className="btn-primary">Partner with Us</NavLink>
          </div>
          <div className="hero-visual">
            <img src={illustration} alt="AI, Data, and Cloud visualization" className="responsive-img" />
          </div>
        </section>
      </main>
      <aside className="temporary-notice">
        <p><strong>NOTE:</strong> This is a temporary landing page. It will be updated soon with our full website.</p>
      </aside>
      <Footer />
    </>
  );
}
